import React, { useEffect, useMemo } from 'react';
import { Button, Card, Form, Input, Row, Col, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { LoadingOutlined } from '@ant-design/icons';

export default function BasicSettings({ loading, pending, settings, onSave }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const values = useMemo(
    () => ({
      owner: settings.email,
    }),
    [settings]
  );

  useEffect(() => {
    form.setFieldsValue(values);
  }, [values]);

  return (
    <Card className="settings-card" title={t('company')} bordered={false}>
      <Spin spinning={loading} indicator={<LoadingOutlined />}>
        <Form
          form={form}
          layout="vertical"
          name="company-settings-edit"
          onFinish={() => {}}
        >
          <Row gutter={12}>
            <Col span={12}>
              <Form.Item name="companyName" label={t('company-name')}>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="owner" label={t('owner')}>
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Card>
  );
}
